import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Display, Meta, Button } from '../components/Atoms';
import { Sprout, EmptyBed } from '../components/Illustrations';

/**
 * NotFound - strona 404 w stylu Terroir.
 *
 * Wyświetlana dla wszystkich nieistniejących ścieżek (catch-all w App.js).
 * Bez auth (publiczna).
 */

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="redesign-root" style={{
      minHeight: 'var(--t-vh)',
      background: 'var(--t-bg)',
      color: 'var(--t-text)',
      fontFamily: 'var(--t-sans)',
      display: 'grid',
      placeItems: 'center',
      padding: 32,
    }}>
      <div style={{
        maxWidth: 520, textAlign: 'center',
      }}>
        <div style={{
          marginBottom: 28,
          display: 'flex', justifyContent: 'center',
        }}>
          <EmptyBed size={160} color="var(--t-line-2)" />
        </div>

        <Meta color="amber" style={{ marginBottom: 16 }}>404 — strona nie istnieje</Meta>

        <Display size={'clamp(48px, 8vw, 72px)'} style={{
          display: 'block', letterSpacing: '-.04em', lineHeight: 0.95,
          marginBottom: 18,
        }}>To pole ugorem leży</Display>

        <div style={{
          fontSize: 16, color: 'var(--t-text-dim)',
          lineHeight: 1.55, marginBottom: 36,
        }}>
          Strona, której szukasz, nie istnieje albo została przeniesiona.
          Może adres się pomylił, a może coś tu jeszcze nie wzeszło.
        </div>

        <div style={{
          display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap',
        }}>
          <Button variant="primary" onClick={() => navigate('/')}>
            ← Strona główna
          </Button>
          <Button variant="ghost" onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/dashboard')}>
            Wróć
          </Button>
        </div>

        <div style={{ marginTop: 50 }}>
          <Link to="/pomoc" style={{
            fontFamily: 'var(--t-mono)', fontSize: 11,
            letterSpacing: '.18em', textTransform: 'uppercase',
            color: 'var(--t-text-mute)', textDecoration: 'none',
          }}>↳ Centrum pomocy</Link>
        </div>
      </div>
    </div>
  );
}
